import React, { useState } from 'react'
import { Modal } from 'antd-mobile';
import SearchLocation from '../../components/order/receive-method/SearchLocation'
import useDidMountEffect from '../../hooks/useDidMountEffect'

import { useDispatch, useSelector } from 'react-redux'
import { calcDistance, setDeliverPosition } from '../../actions/orderActions'
import { toggleLoginForm } from '../../actions/appActions'
import { getListAddress, getMaxDistanceSupportShipping, getRestaurantSettings } from '../../selectors'
import { useTranslation } from 'react-i18next';
import usePlacesService from "react-google-autocomplete/lib/usePlacesAutocompleteService";
import { getUserAddressFromAddressComp, makeAddressCalcDistance } from '../../utils';

const alert = Modal.alert;

const SearchLocationContainer = ({ isOpen, onSubmitLocationSuccess }) => {
    const userAddress = useSelector(getListAddress);
    const maxDistanceSupport = useSelector(getMaxDistanceSupportShipping);
    const { deliver_setting: { map_key_direction, region_google } = {} } = useSelector(getRestaurantSettings);

    const {
        placesService,
        placePredictions,
        getPlacePredictions,
    } = usePlacesService({ apiKey: map_key_direction || ' ', language: 'en' });

    const [address, setAddress] = useState('')
    const [addressObjSelected, setAddressObjSelected] = useState(null)
    const [error, setError] = useState('')
    const dispatch = useDispatch()

    const { t } = useTranslation();

    const openLoginForm = e => {
        e && e.preventDefault()
        dispatch(toggleLoginForm(true))
    }

    const handleCalcDistance = address => {
        setAddressObjSelected(address);
        setAddress(address.description);
    }

    const handleCalcDistanceSuccess = response => {
        if ((response.distance || 0) / 1000 >= maxDistanceSupport) {
            alert(
                '',
                t('modalOrderMethod.mesOutsideShippingSupportArea', { distance: maxDistanceSupport }),
                [{ text: 'Ok', onPress: () => {} }]
            )
        } else {
            dispatch(setDeliverPosition(response));
            onSubmitLocationSuccess(response);
        }
    }

    const handleSubmit = e => {
        e && e.preventDefault()

        if (!placePredictions.length || !placesService) {
            return setError('address invalid');
        }

        let destinations = address, addressObj = addressObjSelected;
        if (!addressObj) {
            destinations = placePredictions[0].description || '';
            addressObj = placePredictions[0] || [];
        }
       
       try {
        placesService.getDetails(
            { placeId: addressObj.place_id },
            placeDetails => {
                const addressComps = placeDetails.address_components || [];

                const country = addressComps.find(c => c.types?.includes('country'))?.short_name;
                const validKey = country === 'VN'
                    ? ['route']
                    : ['locality', 'postal_code', 'route'];
                for (let key of validKey) {
                    if (!addressComps.find(component => component.types?.includes(key))) {
                        console.log(key)
                        return setError('address invalid');
                    }
                }
                const { userCity, userStreet, userAddressNumber, userPostcode } = getUserAddressFromAddressComp(addressComps);

                const geometry = placeDetails.geometry?.location;
                const lat = geometry ? geometry.lat() : undefined;
                const lng = geometry ? geometry.lng() : undefined;

                dispatch(calcDistance({
                    params: {
                        destinations: makeAddressCalcDistance(userStreet, userAddressNumber, userCity, userPostcode),
                        fromSearchForm: true,
                        addressComponents: addressComps,
                        skipSetDeliverPosition: true,
                        latitude: lat,
                        longitude: lng,
                    },
                    onDone: handleCalcDistanceSuccess,
                }));
            }
        )
       } catch (error) {
        console.log(error)
       }
    }

    const handleSelectAddress = e => {
        const { value } = e.target
        const address = userAddress[value]
        const { addressNumber, street, city, zipCode } = address

        dispatch(
            calcDistance({
                params: {
                    destinations: makeAddressCalcDistance(street, addressNumber, city, zipCode),
                    addressData: {
                        selectAddress: value,
                        ...address,
                    },
                    skipSetDeliverPosition: true
                },
                onDone: handleCalcDistanceSuccess,
            })
        )
    }

    const handleChangeAddress = value => {
        setAddress(value);
        setAddressObjSelected(null);
    }

    useDidMountEffect(() => {
        !isOpen && setAddress('') && setError('')
    }, [ isOpen ])

    useDidMountEffect(() => {
        getPlacePredictions({ input: address ? address + region_google : '' });
    }, [ address ])

    return (
        <SearchLocation
            address={address}
            setAddress={handleChangeAddress}
            error={error}
            setError={setError}
            listLocation={placePredictions || []}
            handleCalcDistance={handleCalcDistance}
            handleSubmit={handleSubmit}
            openLoginForm={openLoginForm}
            userAddress={userAddress}
            handleSelectAddress={handleSelectAddress}
        />
    )
}

export default SearchLocationContainer